// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum GroupControl {
  SEC = 0,
  ARS = 1,
  AllRunUp = 2,
  AllRunDown = 3,
  AllStop = 4,
}
